import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const PageTitle = ({ title, suffix = "Gakuen Technologies" }) => {
  const location = useLocation();

  useEffect(() => {
    if (title) {
      document.title = `${title} | ${suffix}`;
    } else {
      document.title = "Gakuen Technologies | RoboInSci";
    }
  }, [title, suffix, location]);

  return null;
};

export default PageTitle;
